import SolidesLanding from "@/components/landing/SolidesLanding";

export default function Landing() {
  return <SolidesLanding />;
}
